<template>
    <div class="main-container p-3">
        <div class="d-flex align-items-center mb-4">
            <b-button variant="light" @click="goback()" class="mr-3 rounded-circle shadow-sm">
                <b-icon icon="arrow-left"></b-icon>
            </b-button>
            <h4 class="mb-0 font-weight-bold text-dark">{{ $route.query.desc }}</h4>
        </div>

        <b-card>
            <b-row>
                <b-col>
                    <b-form-select v-model="field" :options="findfied" required placeholder="ຄົ້ນຫາຕາມ">
                    </b-form-select>
                </b-col>
                <b-col>
                    <b-form-input type="text" v-model="find" placeholder="ຕ້ອງການຄົ້ນຫາ" required>
                    </b-form-input>
                </b-col>
                <b-col>
                    <b-button variant="outline-primary" @click="onSearch">
                        <b-icon icon="search"></b-icon> ຄົ້ນຫາ....
                    </b-button>
                    <b-button  v-show="menu.addnew" variant="outline-success" @click="addnew"> {{ $t("button.add") }} </b-button>


                </b-col>
            </b-row>


        </b-card>

        <b-table head-variant="light" hover :fields="fields" :items="items" class=" border" responsive="sm">
            <!-- A virtual column -->
            <template #cell(index)="data">
                {{ data.index + 1 }}
            </template>
            <template #cell(action)="data">
                <b-link v-show="menu.edit"  @click="edit(data.item._id)">
                    <b-icon icon="pencil"></b-icon>
                </b-link>
                <b-link   v-show="menu.del"   @click="del(data.item._id)">
                    <b-icon icon="trash" variant="danger" ></b-icon>
                </b-link>
            
            <!-- <b-button variant="outline-primary" @click="edit(data.item.id)"> {{ $t("button.edit") }} </b-button>
                <b-button variant="outline-danger" @click="del(data.item.id)"> {{ $t("button.delete") }} </b-button>
             -->
            </template>
        </b-table>
        <infinite-loading @infinite="infiniteHandler" spinner="spiral">
            <div slot="spinner">Loading...</div>
            <div slot="no-more">No more data</div>
            <div slot="no-results">No results data</div>
        </infinite-loading>
    </div>

</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from 'moment'
export default {

    data() {
        return {
            page: 0,
            field: '',
            find: '',
            menuid: this.$route.query.id,
            pkey: "",
            table: "",
            fields: [],
            items: [],
            findfied: [],
            menu: [],
            user:[]
        }
    },
    components: {
        InfiniteLoading,
    },
    filters: {
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        formatdate(value){
         if (value) {
            return moment(String(value)).format('MM/DD/YYYY hh:mm')
          }
      },

    },
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);

        axios
            .get(
                this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id
            )
            .then((response) => {
                // JSON responses are automatically parsed.
            //    this.menu = response.data.menu
                this.pkey = response.data.pkey
                this.table = response.data.table
                this.fields = JSON.parse(response.data.fields)
                this.items = response.data.items
                this.fields.forEach((item) => {
                    this.findfied.push({
                        value: item.key,
                        text: item.label
                    })
                })

            })
            .catch((e) => {
                console.log(e);
            });


            axios
            .get(
                this.$store.getters.getBaseUrl + "/getMenuOne/" + this.menuid  +"?level_id="+ this.user.level.level_id
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                console.log(response.data[0])
                this.menu = response.data[0]
             

            })

    },
    methods: {
        goback() {
            this.$router.go(-1)
        },
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },

        formatDate(dd) {
            let d=new Date(dd)
            return [
                this.padTo2Digits(d.getDate()),
                this.padTo2Digits(d.getMonth() + 1),
                d.getFullYear(),
            ].join('/');
        },
        infiniteHandler($state) {
            this.busy = true;
            setTimeout(() => {

                axios
                    .get(
                        this.$store.getters.getBaseUrl +
                        "/dynamic_table/" + this.menuid +
                        "?offset=" + this.page + "&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id,
                        {
                            headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                        }
                    )
                    .then((response) => {
                        //this.pkey=response.data.pkey
                        if (this.page == 0) {
                            // this.fields = JSON.parse(response.data.fields)

                            // this.fields.forEach((item) => {
                            //     this.findfied.push({
                            //         value: item.key,
                            //         text: item.label
                            //     })
                            // })

                            this.items = response.data.items;
                            this.page++;
                        } else {

                            if (response.data.items.length != 0) {
                                this.page++;
                                this.items = this.items.concat(response.data.items);
                                $state.loaded();
                            }else{
                               $state.complete(); 
                            }
                            
                        }
                    });
                $state.loaded();
                this.busy = false;
            }, 200);
        },

        onSearch() {
            axios
                .get(
                    this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&" + "&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.items = response.data.items;
                    this.page = 0;

                })
                .catch((e) => {
                    console.log(e);
                });
        },
        addnew() {
            this.$router.push(this.menu.formnew_web + this.$route.query.id);
        },
        edit(id) {
            //  console.log(this.rowSlect[0].doc_code);
            //  const Values = Object.values(this.rowSlect[0]);
            this.$router.push(
                this.menu.formedit_web  +
                this.$route.query.id +
                "/" +
                this.pkey +
                "/" +
                id
            );
        },
        del(code) {

            let params = {
                table: this.table,
                pkey: this.pkey,
                code: code
            }
            this.$bvModal.msgBoxConfirm('ກະລຸນາຢືນຢັນ ທ່ານຕ້ອງການລົບລາຍການນີອອກຈາກລະບົບ.', {
                title: 'Please Confirm',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value == true) {
                        axios.post(this.$store.getters.getBaseUrl + '/del', params,{
                            headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                        })
                            .then((res) => {
                                if (res.data.code == 1) {
                                    this.$bvToast.toast(`ລົບລາຍການອອກສຳເລັດແລ້ວ.`, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })

                                    axios
                                        .get(
                                            this.$store.getters.getBaseUrl + "/dynamic_table/" + this.menuid + "?offset=0&fld=" + this.field + "&find=" + this.find,
                                            {
                                                headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                                            }
                                        )
                                        .then((response) => {
                                            // JSON responses are automatically parsed.
                                            this.pkey = response.data.pkey
                                            this.table = response.data.table
                                            this.fields = JSON.parse(response.data.fields)
                                            this.items = response.data.items
                                            this.fields.forEach((item) => {
                                                this.findfied.push({
                                                    value: item.key,
                                                    text: item.label
                                                })
                                            })

                                        })
                                        .catch((e) => {
                                            console.log(e);
                                        });

                                    this.page = 0

                                } else {
                                    this.$bvToast.toast(res.data.msg, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })



                                }
                                console.log(res.data)
                            })
                            .catch(err => {

                                console.error(err);
                            })
                    }
                    //this.boxTwo = value
                })
                .catch(err => {
                    console.error(err);
                })

        }
    },

}
</script>

<style scoped>
.main-container {
    background-color: #f8f9fa;
    min-height: 100vh;
}
.rounded-circle {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>